// src/config/brand.js

export const BRAND_CONFIG = {
    appName: "ERI HUB",
    appSubtitle: "AI Wellness",
    // Used for the circular avatar placeholder if no user is logged in
    defaultInitials: "G", 
    
    // The Logo Definition (EAS Logo Path)
    logo: {
        viewBox: "0 0 2722.94 2518.59",
        // This is the specific SVG path data from your original index.html
        path: "M1612.65,730.75s123.54,560.85,165.05,749.97c11.81,53.88,55.67,95.03,110.2,103.29,88.14,13.85,360.12,29.03,378.07-97.24,23.07-162.25-488.4-103.31-438.55-438.43,52.19-350.85,586.44-319.17,746.91-318.66l-77.12,246.5c-40.94-9.63-375.63-6.47-366.68,94.91,10.9,123.4,490.36,72.38,396.92,464.83-53.14,223.19-183.99,298.18-410.4,297.68l-1984.73-.13L409.83,731.08h731.44l-94.97,243.92-443.66.13-48.5,162.88h352.89l-90.14,231.58-314.32.48-54.51,194.59h408.27l507.56-834.97,248.75,1.05ZM1296.28,1488.2l134.81-139.17,114.49,140.61-95.17-513.45-374.69,656.74,188.63-187.48,42.18,42.65",
        fill: "#ffffff" // Default fill color (can be overridden via className)
    }
};

export default BRAND_CONFIG;